import script from "./orderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDetails.vue?vue&type=script&setup=true&lang=js"

import "./orderDetails.vue?vue&type=style&index=0&id=2641aa86&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2641aa86"]])

export default __exports__